import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cstp-registry',
  templateUrl: './cstp-registry.component.html',
  styleUrls: ['./cstp-registry.component.css']
})
export class CstpRegistryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
